import { useMemo } from 'react';
import { FormField } from '@src/components/SmartDataTable/types';
import { PAYMENT_TYPE_OPTIONS } from '../../constants';

export const useInsideStockTransactionsFormFields = (): FormField[] => {
  return useMemo(
    () =>
      [
        // Row 1: Purchase ID, Amount
        {
          name: 'purchase_id',
          label: 'Purchase ID',
          type: 'select',
          required: false,
          searchable: true,
          searchFields: ['id'],
          optionLabel: (item: any) =>
            `Purchase #${item.id} - ₹${item.bill_amount}`,
          optionValue: 'id',
          resource: 'inside_inventory_purchases',
          placeholder: 'Select purchase...',
          layout: { span: 12 },
        },
        {
          name: 'amount',
          label: 'Amount',
          type: 'number',
          required: true,
          placeholder: '0.00',
          min: 0,
          step: 0.01,
          layout: { span: 12 },
        },

        // Row 2: Transaction Type
        {
          name: 'transaction_type',
          label: 'Payment Type',
          type: 'select',
          required: true,
          options: [...PAYMENT_TYPE_OPTIONS],
          placeholder: 'Select payment type...',
          layout: { span: 24 },
        },
      ] as FormField[],
    []
  );
};
